// The interruption card (components/Notices/spec.md § Anatomy; components/Failures/spec.md
// § Anatomy and parameters). The card is never tinted: severity colours the icon only.
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--qs-space-16);
  width: 100%;
  max-width: 460px;
  margin: var(--qs-space-32) auto 0;
  // 28 has no space token: 24 + 4.
  padding: calc(var(--qs-space-24) + var(--qs-space-4)) var(--qs-space-32);
  background: var(--qs-color-surface);
  border: 1px solid var(--qs-color-line);
  border-radius: var(--qs-radius-lg);
  text-align: center;
  animation: card-in var(--qs-motion-dur-settle) var(--qs-motion-ease-settle) both;
}

@keyframes card-in {
  from {
    opacity: 0;
    transform: translateY(var(--qs-motion-travel-max));
  }
}

@media (max-width: 719px) {
  .card {
    padding: var(--qs-space-24) var(--qs-space-20);
  }
}

.cardIcon {
  flex: none;

  &[data-tone='info'] {
    color: var(--qs-color-info);
  }

  &[data-tone='warning'] {
    color: var(--qs-color-warning);
  }

  &[data-tone='error'] {
    color: var(--qs-color-error);
  }
}

.cardTitle {
  font-family: var(--qs-font-display);
  font-style: italic;
  font-size: var(--qs-type-display-s-size);
  line-height: var(--qs-type-display-s-lh);
  color: var(--qs-color-text);
  margin: 0;
}

.cardBody {
  max-width: 460px;
  font-family: var(--qs-font-text);
  font-size: var(--qs-type-body-size);
  line-height: var(--qs-type-body-lh);
  color: var(--qs-color-text-soft);
  margin: 0;
}

.cardActions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--qs-space-12);
  margin-top: var(--qs-space-4);
}

// The sign-in POST wraps its button; the form must not break the actions' row.
.cardForm {
  display: contents;
}

.cardAction {
  min-height: var(--qs-target-option-min-height);
}

// A failure line (core/ui/Notice): the spec's sentences keep their case — the shared Notice
// lowercases its one-word lines, and the attribute selector outranks its single class.
.line[data-kind] {
  margin: var(--qs-space-16) auto 0;
  font-size: var(--qs-type-small-size);
  line-height: var(--qs-type-small-lh);
  text-align: center;
  text-transform: none;
}
